import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';
import { UPSERT_ASSET_MK } from '../components/UpsertAssetModal/UpsertAssetModal.meta';
import { queryKeys } from './queryKeys';
import { UpsertRealEstateDTO } from '../forms/RealEstate/RealEstateForm.meta';

export const UPSERT_REAL_ESTATE_ENDPOINT = '/Consumer/OtherAssetsUpdate/SaveRealEstate';

const upsertRealEstate = (body: UpsertRealEstateDTO): Promise<null> => {
  return authFetch(UPSERT_REAL_ESTATE_ENDPOINT, {
    method: 'POST',
    ...httpBodyOptions(body, true),
  });
};

interface Params {
  clientId: string;
}

export const useUpsertRealEstateMutation = ({ clientId }: Params) => {
  const queryClient = useQueryClient();

  return useMutation(upsertRealEstate, {
    mutationKey: [UPSERT_ASSET_MK, 'realEstate'],

    async onSuccess() {
      await queryClient.refetchQueries(queryKeys.otherAssets(clientId));
    },
  });
};
